import O1HD from "../../../../engines/gameEngine";
import DreamHousePrefab from "../DreamHousePrefab";
import spendGameManager from "../../manager/spendGameManager";
import PageHasInvestment from "./PageHasInvestment";
import PageNewProject from "./PageNewProject";

const {ccclass, property} = cc._decorator;

/**
 * 项目栏 预制体
 */
@ccclass
export default class ProjectBarPrefab extends cc.Component {

    @property({type:cc.Node,displayName:"已投资按钮"})
    hasInvestmentNode : cc.Node = null;
    @property({type:cc.Node,displayName:"新项目按钮"})
    newProjectBtnNode : cc.Node = null;
    @property({type:cc.PageView,displayName:""})
    pageView : cc.PageView = null;
    @property(cc.Node)
    pageHasInvestNode : cc.Node = null;
    @property(cc.Node)
    pageNewNode : cc.Node = null;

    private mGameLayer : spendGameManager;
    private mParentScript : DreamHousePrefab;

    onLoad () {}

    start () {

    }

    bindData( define : string , gameLayer : spendGameManager, parentScript : DreamHousePrefab){
        this.mGameLayer = gameLayer;
        this.mParentScript = parentScript;
        this.changePage( define );
        this.pageHasInvestNode.getComponent(PageHasInvestment).bindData( this.mGameLayer  );
        this.pageNewNode.getComponent(PageNewProject).bindData( this.mGameLayer , this.mParentScript );
    }

    onBtnChoosePage( e , define : string){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        this.changePage( define );
    }

    changePage( define : string ){
        if ( define == "0" ) {
            this.hasInvestmentNode.active = true;
            this.newProjectBtnNode.active = false;
            this.pageView.setCurrentPageIndex( 0 );
        }else{
            this.hasInvestmentNode.active = false;
            this.newProjectBtnNode.active = true;
            this.pageView.setCurrentPageIndex( 1 );
        }
    }

    /**
     * 返回
     */
    onBtnBack(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        this.node.removeFromParent();
        this.node.destroy();
    }

}
